export enum BillLadingFeeType {
    FeeReceiver = 1,
    FeeDelivery = 2,
    FeePostOfficeDelivery = 3,
    FeeOther = 4,
    // FeeTranshipment = 5,
    FeeDiscountCustomer = 6,
    FeePartnerReceive = 7,
    FeePartnerDelivery = 8,
    FeeError = 9,
    FeeConnect = 10,
    FeeLading = 11,
    FeeFixed = 12,
}
